import React, { useState, useEffect } from "react";
import axios from "axios";
import CustomButton from "components/common/Button/CustomButton";
import ModalSkeleton from "components/Modals/ModalSkeleton";
import { apiDeleteRequest } from "helpers/Requests";
import { getUrlRole } from "Utils/utils";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { getSpSetting } from "store/selector/sp.selector";
import { getParticipantLabel } from "Constants/constant";
//import uuid from "react-tabs/lib/helpers/uuid";

const DeleteParticipantModal = (props) => {
  const { isShow, handleClose, participantId, isUserGracePeriodOver, settings } = props;
  const participantLabel = getParticipantLabel(settings?.care_sector, false) || "Participant";
  const { uuid } = useParams();
  const navigate = useNavigate();

  const [request, setRequest] = useState({
    isRequested: false,
    isSuccess: false,
    isFailed: false,
  });


  const handleDelete = async () => {
    if (isUserGracePeriodOver) {
      return;
    }

    setRequest({ ...request, isRequested: true });

    try {
      const response = await apiDeleteRequest(
        `/${getUrlRole()}/participant-delete/${uuid}`
      );
      if (response.status === 204) {
        setRequest({ isRequested: false, isSuccess: true, isFailed: false });
        toast.success(`${participantLabel} deleted successfully!`);
        handleClose();
        navigate(-1);
      }
    } catch (error) {
      setRequest({ isRequested: false, isSuccess: false, isFailed: true });
      console.error("Failed to delete participant:", error);
    }
  };

  const modalFooter = () => (
    <>
      <CustomButton
        showLoading={request.isRequested}
        isDisabled={request.isRequested || isUserGracePeriodOver}
        label={`Yes, delete ${participantLabel}`}
        clickHandler={handleDelete}
        variant='danger'
      />

      <CustomButton
        clickHandler={handleClose}
        label='No, cancel changes'
      />
    </>
  );

  return (
    <>
      {isShow && (
        <ModalSkeleton
          title={`Delete ${participantLabel}`}
          cssClass='w-[50%]'
          isOpen={isShow}
          closeModal={handleClose}
          modalFooter={modalFooter()}
        >
          <p className='text-gray-700'>
            Are you sure you want to delete this {participantLabel.toLowerCase()}? <br />Deleting a{' '}
            {participantLabel.toLowerCase()} will permanently erase all associated data, including
            forms, rostering, reports etc. This action is
            irreversible.
          </p>
          <p className='text-xs text-gray-500 mt-2'>
            This action will be recorded in the audit log.
          </p>
        </ModalSkeleton>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  settings: getSpSetting(state),
});

export default connect(mapStateToProps)(DeleteParticipantModal);
